import {RegisterType} from '../component-registry';
import {GuidedUiKeywordSuggestions} from '../../models/Guided.schema';
import {GuidedQuickLinkDetails} from '../../models/quick-link';
import {onlyMatchingSource} from '../../utils';
import {mapGuidedV2ItemToGuidedV2KeywordSuggestions} from '../mappers';
import {SuggestionsBar} from '../suggestions/guided-suggestions';
import {h} from '@stencil/core';
import type {GuidedV2FactoryState} from '../../models/ui';

export class GuidedV2KeywordSuggestions {
  /**
   * Shows the keyword suggestions in the guided search. Keywords expanding
   * current search query. The same searcher as in Popular Queries but with
   * search term for the query
   * @param inputData {GuidedV2KeywordSuggestions}
   * @param state {GuidedV2FactoryState}
   */
  @RegisterType(GuidedUiKeywordSuggestions.type)
  render<T extends GuidedQuickLinkDetails>(
    inputData: GuidedUiKeywordSuggestions,
    state: GuidedV2FactoryState<T>,
  ) {
      const {
        itemSources,
        label,
        maxItems,
      } = inputData; //comes from configuration

      const {
        labelProvider,
        results, //the API response
        // searchTerm,
        eventEmitters,
        isMobile,
      } = state;

      // console.log('Keyword suggestion results',results);

      const matchingResults = results
        .filter(onlyMatchingSource(itemSources))
        .slice(0, maxItems)
        .map(mapGuidedV2ItemToGuidedV2KeywordSuggestions)
    ;
    // console.log('Keyword suggestion matching items',matchingResults);

      if (matchingResults.length == 0)
        return <span data-err="Keyword suggestions list is empty"></span>;

      //main label: `guided-v2.keyword-suggestions.label.${label}`
      //secondary label:  'guided-v2.keyword-suggestions.label'
      //falback: label
      const suggestionsLabel = labelProvider(
        `guided-v2.keyword-suggestions.label.${label}`,
        labelProvider( //here is double-item for the label if there are multiple `guided-v2.keyword-suggestions.label`
        // items. So they should be distinct. That's why the first one is more specific
          'guided-v2.keyword-suggestions.label',
          label
        )
      );

      return <div class="guided-v2-keyword-suggestions add-selector-strength"><SuggestionsBar
        results={matchingResults}
        label={suggestionsLabel}
        eventEmitters={eventEmitters}
        isMobile={isMobile}
      /></div>;
  }
}
